const $ = window.jQuery;
const Backbone = require('backbone');
const Marionette = require('backbone.marionette');
const app = require('../app.js');
const clubs = require('../data/clubs.js');
const studios = require('../data/studios.js');
const parameters = require('../data/parameters.js');
const TerminalView = require('../views/terminal.js');

const executeClub = function(clientToken, club, studioList, studioIds) {
  parameters.set('client_token', clientToken);
  app.rootView.showChildView(
    'content',
    new Marionette.ItemView({
      template() {
        return '<p style="text-align: center; margin-top: 45vh">Chargement en cours ...</p>';
      }
    })
  );

  club
    .fetch()
    .then(() =>
      $.when(
        club.get('activities').fetch(),
        club.get('activitygroups').fetch(),
        club.get('studios').fetch(),
        club.get('coaches').fetch()
      )
    )
    .then(() => {
      app.rootView.showChildView(
        'content',
        new TerminalView({
          model: new Backbone.Model({
            clientToken,
            club,
            studios: studioList,
            studioIds
          })
        })
      );
      parameters.set('clubId', club.get('id'));
    });
};

app.router.route(':clientToken/clubs/:clubId/planning', (clientToken, clubId) => {
  const club = clubs.findWhere(
    {
      id: clubId
    },
    true
  );

  executeClub(clientToken, club, null);
});

app.router.route(':clientToken/clubs/:clubId/planning/studios/:studioIds', (clientToken, clubId, studioIds) => {
  const club = clubs.findWhere(
    {
      id: clubId
    },
    true
  );

  const studioList = [];

  if (studioIds.indexOf(',') !== -1) {
    const studioIdsArray = studioIds.split(',');

    $.each(studioIdsArray, (index, studioId) => {
      studioList.push(
        studios.findWhere(
          {
            id: studioId
          },
          true
        )
      );
    });
  } else {
    studioList.push(
      studios.findWhere(
        {
          id: studioIds
        },
        true
      )
    );
  }

  executeClub(clientToken, club, studioList, studioIds);
});

module.exports = function(clientToken, club, options) {
  const url = app.router.generate(':clientToken/clubs/:clubId/planning', {
    clientToken,
    clubId: club.get('id')
  });
  app.router.navigate(url, options);

  executeClub(clientToken, club, null);
};



// WEBPACK FOOTER //
// ./src/commands/goto-planning.js